import {PropsWithChildren} from "react";
import {createContext} from "../../../../../context/create-context";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {Breadcrumb, Button, Result} from "antd";
import {Link, useParams} from "react-router-dom";
import {GetStoreServiceApiResponse} from "../../../../../react-query-hooks/store/services/get-store-service/types";
import {useGetStoreServiceApi} from "../../../../../react-query-hooks/store/services/get-store-service";
import {DashboardWrapper} from "../../../../../layouts/dashboard-wrapper";
import {useGetStoreServicePortfolioImages} from "../../../../../react-query-hooks/store/services/upload-content";
import {GetStoreServicePortfolioImagesApiResponse} from "../../../../../react-query-hooks/store/services/upload-content/types";

type GetStoreServiceState = {
  storeServiceData: GetStoreServiceApiResponse;
  portfolioImages: GetStoreServicePortfolioImagesApiResponse;
  isFetchingStoreService: boolean;
  isLoadingStoreService: boolean;
};

type GetStoreServiceContextState = {
  state: GetStoreServiceState;
};

const [useContext, ContextProvider] = createContext<GetStoreServiceContextState>();

export const useGetStoreServiceContext = useContext;

export const GetStoreServiceProvider = ({children}: PropsWithChildren) => {
  const {id} = useParams();
  const getStoreServiceQuery = useGetStoreServiceApi(Number(id));
  const getStoreServicePortfolioImages = useGetStoreServicePortfolioImages(Number(id));

  if (getStoreServiceQuery.isLoading) {
    return (
      <DashboardWrapper pageTitle={`Edit Product`}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/products">Store</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit service</Breadcrumb.Item>
        </Breadcrumb>{" "}
        <FullPageLoader />
      </DashboardWrapper>
    );
  }

  if (getStoreServiceQuery.isError) {
    return (
      <DashboardWrapper pageTitle={`Edit Product`}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/products">Store</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit service</Breadcrumb.Item>
        </Breadcrumb>{" "}
        <Result
          status="500"
          title="Sorry, something went wrong."
          subTitle="Error fetching service"
          extra={
            <Button
              type="primary"
              size="small"
              onClick={() => getStoreServiceQuery.refetch()}
            >
              Try again
            </Button>
          }
        />
      </DashboardWrapper>
    );
  }

  const state: GetStoreServiceState = {
    storeServiceData: getStoreServiceQuery.data,
    portfolioImages: getStoreServicePortfolioImages.data ?? [],
    // storeServiceData: {
    //   productService: {
    //     booking_questions: [],
    //     bookingQuestions: [],
    //     cover_images: [],
    //     createdAt: "",
    //     currencies: [],
    //     deleted_at: null,
    //     delivery_timeframe_unit: "days",
    //     delivery_timeframe_value: 1,
    //     description: "",
    //     hideFromProfile: false,
    //     name: "",
    //     request_phone_number: false,
    //     slug: "",
    //     statusId: 1,
    //     tiny_url: "",
    //     updatedAt: "",
    //     url_redirect: "",
    //     userId: 1,
    //     id: Number(id),
    //   },
    // },
    isFetchingStoreService: getStoreServiceQuery.isFetching,
    isLoadingStoreService: getStoreServiceQuery.isLoading,
  };

  return <ContextProvider value={{state}}>{children}</ContextProvider>;
};
